module.exports = __webpack_public_path__ + "media/images/quality-ae394a822e8b75ee09e50a4cac08f972.png";